import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PageStateService {
  currentPage = 1;
  isFilter = false;
  filternewDataBenefits: any[] = [];
  usedFilterPanelValidPlan = false;
  filterplanIdchecked: any;
  usedFilterPanelValidTypes = false;
  filterTypeidChecked: any;
  savedSearchData: any[] = [];
  searchName!: string;
  searchActive = false;
  usedFilterPanelValidAntiques = false;
  filterAntiquesIdChecked: any;
  selected_category!:number;
}
